<template>
  <div
    v-show="currentIndex === index"
    class="swiper-slide"
  >
    <div class="banner__item">
      <slot />
      <LoaderBanner
        v-if="size > 1"
        :timer-seconds="timerSeconds"
      />
    </div>
  </div>
</template>

<script setup>
import LoaderBanner from '@/components/baner/ThemedBanners/LoaderBanner.vue';

const props = defineProps({
  currentIndex: {
    type: Number
  },
  index: {
    type: Number
  },
  timerSeconds: {
    type: Number
  },
  size: {
    type: Number
  }
});
</script>

<style scoped>

.swiper-slide {
  display: inline-block;
  width: 100%;
  animation: previewSwipe .7s 1 ease;
}

.banner__item {
  transition-property: opacity, transform;
  transition-timing-function: ease;
  transition-duration: .5s;
  position: relative;
  overflow: hidden;
  border-radius: 16px;
}

@keyframes previewSwipe {
  0%{
    opacity: .5;
    transform: scale(.95);
  }
  100%{
    opacity: 1;
    transform: none;
  }
}

</style>
